import TagManager from "react-gtm-module";
import { logInfo } from "src/services/logger";

declare global {
  interface Window {
    dataLayer: Array<any>;
  }
}

export const DTLayer = (() => {
  const dispatch = (event: string, dataLayer: Object) => {
    if (self.status === "initialized")
      window.dataLayer.push({
        event,
        ...dataLayer,
      });
  };

  const self: {
    status: string;
    gtmId: string | null;
    dispatch: typeof dispatch;
  } = {
    status: "pending",
    gtmId: null,

    // Functions
    dispatch,
  };

  return self;
})();

export default function createDataLayer(gtmId: string) {
  logInfo("DataLayer: iniciado", { gtmId });

  const tagManagerArgs = {
    gtmId,
    dataLayer: {
      env: import.meta.env.DEV ? "local" : "production",
    },
  };

  TagManager.initialize(tagManagerArgs);

  // Update Object
  DTLayer.status = "initialized";
  DTLayer.gtmId = gtmId;
}
